import React from "react";
import Table from "./Components/Table";
import { PublishStatus } from "../../../../service/score";

interface RulesPaperProps {
    courseNo: string;
    courseSeq: string;
    status: PublishStatus | null; //成绩单状态
    publishLoading: boolean; //已发布状态
}

const Index = ({
    courseNo,
    courseSeq,
    status,
    publishLoading
}: RulesPaperProps) => {
    return (
        <Table
            courseNo={courseNo}
            courseSeq={courseSeq}
            status={status}
            publishLoading={publishLoading}
        />
    );
};

export default Index;
